import List from "@/components/list";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const AccountTableConfig = [
    {
      label: "推送方式",
      prop: "smsPushTypeName",
      minWidth: "80"
    },
    {
      label: "业务类型",
      prop: "smsBizTypeName",
      minWidth: "80"
    },
    {
      label: "接收手机号码",
      prop: "toMobile",
      minWidth: "100"
    },
    {
      label: "接收人",
      prop: "toUserName",
      minWidth: "80"
    },
    {
      label: "发送IP地址",
      prop: "ipAddress",
      minWidth: "100"
    },
    {
      label: "短信内容",
      prop: "smsContent",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "短信状态",
      prop: "smsStatusName",
      minWidth: "80"
    },
    {
      label: "发送时间",
      prop: "smsSendDate",
      minWidth: "120"
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};
export default Table;
